export const NAME = 'campaignSettings-states';

export const dialogs = {
	CONTACT_STATE_USED: 'CONTACT_STATE_USED',
};
